module.exports = __webpack_public_path__ + "img/ldhg_login_img001.f39db0e8.png";